import { laravelAxios } from '../../../../config/axios/laravelAxios';

async function createCompany(data) {
    let body = data;
    const createCompany = await laravelAxios.post('create-company', body);
    return createCompany;
  }

  export default createCompany;